import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from "react-redux";
import {SketchField, Tools} from 'react-sketch2';
import { Grid, Row, Col, Image } from 'react-bootstrap';
import MessageModal from '../../components/message_modal/MessageModal';
import PlatesContainer from '../../components/plates_container/PlatesContainer';
import './signature.css';
import { setImage, setShowError, setErrorType, setIsSigned, setMessageModalVisibility } from "../../redux/actionCreators";
import imageProcess from "../../library/ImageProcess";
import config from '../../config/config';
import FooterContainer from '../../components/footer/FooterContainer';
import MainButton from '../../components/buttons/main_button/MainButton';

class Signature extends Component {

    IMAGE_NAME = 'signature';
    IMAGE_TYPE = 'png';

    PERCENT_PROPORTIONAL_FROM_WIDTH_SIGNATURE = 0.60;
    ADJUST_WIDTH_VALUE = 60;

    CANVAS_VIRTUAL_WIDTH = window.innerWidth * 0.5;
    CANVAS_VIRTUAL_HEIGHT = window.innerHeight * 0.5;
    LAST_SCALE = 1;

    MODAL = {
        multipleSignature: {
            title: 'Confirmación de firma',
            principalMessage: '¿Estás seguro que quieres guardar la firma manuscrita en el sistema y firmar los siguientes contratos?',
            advanceButton: 'Sí, guardar y firmar',
            backButton: 'No, repetir firma'
        },
        defaultSignature: {
            title: 'Confirmación de firma',
            principalMessage: '¿Estás seguro de que la firma es similar a la de tu cédula de identidad?',
            advanceButton: 'Sí, esa es mi firma',
            backButton: 'No, quiero repetirla'
        }
    };

    constructor(props) {
        super(props);
        this.resetSignature = this.resetSignature.bind(this);
        this.updateSignatureDimensions = this.updateSignatureDimensions.bind(this);
        this.backToSign = this.backToSign.bind(this);
        this.advance = this.advance.bind(this);
        this.getImage = this.getImage.bind(this);

        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);

        this.canvas = React.createRef();
        this.layer = React.createRef();
        this.state = {
            width: 0,
            height: 0,
            isDrawing: false,
            signed: false,
            drawingStartTime: 0,
            showSignatureText: true,
        };
    }

    handleMouseDown(e) {
        const timestamp = (new Date()).getTime();
    if (!this.state.isDrawing && this.state.showSignatureText) {
        this.setState({ isDrawing: true, drawingStartTime: timestamp, showSignatureText: false });
    }
    };

    handleMouseUp(e) {
        const endTimestamp = (new Date()).getTime();
        const signed = (endTimestamp - this.state.drawingStartTime) > 0;
        this.setState({ isDrawing: false, drawingStartTime: 0, signed: signed});
    }

    updateSignatureDimensions() {
        const refSignatureParent = ReactDOM.findDOMNode(this.refs.signature_parent);
        if (refSignatureParent) {
            const parentWidth = refSignatureParent.getBoundingClientRect().width - this.ADJUST_WIDTH_VALUE;
            const proportionalHeigth = parentWidth * this.PERCENT_PROPORTIONAL_FROM_WIDTH_SIGNATURE;
            this.setState({width: parentWidth, height: proportionalHeigth});
        }
    }

    /**
     * Add event listener
     */
    componentDidMount() {
        this.updateSignatureDimensions();
        window.addEventListener("resize", this.updateSignatureDimensions.bind(this));    
    }

    /**
     * Remove event listener
     */
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateSignatureDimensions.bind(this));
    }

    isCanvasEmpty = () => {
        const blankCanvas = document.createElement('canvas');
        blankCanvas.width = this.canvas.width;
        blankCanvas.height = this.canvas.height;        
        return this.canvas.toDataURL() === blankCanvas.toDataURL();
    }

    getImage = async () => {
        const image = this.canvas.toDataURL();
        const signatureImage = await imageProcess.resizeImage(
            image,
            parseInt(config.resize_image_width, 10),
            parseInt(config.resize_image_height, 10)
        );
        this.props.setImage(signatureImage);
        this.props.setMessageModalVisibility(true);

    };

    advance = () => {
        this.props.setMessageModalVisibility(false);
        this.props.nextStep();
        this.resetSignature();
    };

    backToSign = () => {
        this.resetSignature();
        this.props.setMessageModalVisibility(false);
    };

    resetSignature = () => {
        this.canvas.clear();
        this.setState({signed: false});
    };


    getMessageModal = () => {
        let modalData = this.MODAL.defaultSignature;
        let secondaryMessage = (
            <Image responsive={true} src={this.props.image} />
        );

        if (this.props.multiple && this.props.multiple.plates) {
            modalData = this.MODAL.multipleSignature;
            secondaryMessage = <PlatesContainer plates={this.props.multiple.plates} />;
        }
        const acceptModalButton = <MainButton className={'next-button'} onClick={this.advance} text={modalData.advanceButton} />;
        const cancelModalButton = <MainButton outline className={'yellow-button'} onClick={this.backToSign} text={modalData.backButton} />;
        const modalButtons = <div className={'content-button'}>{cancelModalButton} {acceptModalButton}</div>;
        return (
            <MessageModal
                title={modalData.title}
                principalMessage={modalData.principalMessage}
                secondaryMessage={secondaryMessage}
                buttons={modalButtons}
                isMultipleSignature={!(this.props.multiple && this.props.multiple.plates)}
            />
        );
    };

    render() {
        let icon;
        const messageModal = this.getMessageModal();
        const signatureStyle = {
            width: this.state.width || 300,
            height: this.state.height || 200,
        };
        if (this.props.stepInfo.icon) {
            icon = require(`../../resources/images/${this.props.stepInfo.icon}`).default;
        }

        return (
            <div className={'signature'}>
                {messageModal}
                <Grid>
                    <Row>
                        <Col xs={12}>
                            <p className='instruction-text'>
                                {this.props.stepInfo && this.props.stepInfo.information}
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} ref="signature_parent" >
                            <div id={'signature-content'} className={'signature-content'} style={signatureStyle}>
                            <SketchField 
                                ref={(view) => {
                                    this.canvas = view
                                }}
                                onMouseUp={this.handleMouseUp}
                                onMouseDown={this.handleMouseDown}
                                width={this.state.width} 
                                height={this.state.height}
                                tool={Tools.Pencil} 
                                lineColor='black'
                                lineWidth={3}
                            />
                            {this.state.showSignatureText && (
                                <span className={'signature-text'} style={{ 
                                    position: 'absolute', 
                                    top: '50%', 
                                    left: '50%', 
                                    transform: 'translate(-50%, -50%)'
                                }}>
                                    Firma con tu dedo aquí
                                </span>
                            )}
                                <span className={'signature-frame'} />
                            </div>

                        </Col>
                    </Row>
                    {this.props.stepInfo.additional ?
                        <React.Fragment>
                            <Row>
                                <Col xs={12}>
                                    <div className={"image"} >
                                        <Image src={icon} />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <div className={'additional'}>
                                        {this.props.stepInfo.additional}
                                    </div>
                                </Col>
                            </Row>
                        </React.Fragment>
                        : null}
                </Grid>
                <div className="buttons-content">
                    <Grid>
                        <FooterContainer>
                        <Col xs={6}>
                            <MainButton
                                text={'Borrar'}
                                onClick={this.resetSignature}
                                className={'yellow-button'}
                                outline
                                disabled={!this.state.signed}
                            />
                        </Col>
                        <Col xs={6}>
                            <MainButton
                                onClick={this.getImage}
                                disabled={!this.state.signed}
                            />
                        </Col>
                        </FooterContainer>
                    </Grid>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        image: state.image,
        showError: state.showError,
        setErrorType: state.setErrorType,
        isSigned: state.isSigned,
        stepInfo: state.stepInfo,
        multiple: state.multiple,
        messageModalVisibility: state.messageModalVisibility,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setImage(image) {
            dispatch(setImage(image));
        },
        setShowError(showError) {
            dispatch(setShowError(showError));
        },
        setErrorType(errorType) {
            dispatch(setErrorType(errorType));
        },
        setIsSigned(isSigned) {
            dispatch(setIsSigned(isSigned));
        },
        setMessageModalVisibility(messageModalVisibility) {
            dispatch(setMessageModalVisibility(messageModalVisibility));
        }

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Signature);
